export default __webpack_public_path__ + "static/media/bts-intro.d70db8c3.mp4";